<div class="mess-shell">
  <!-- <app-mess-header></app-mess-header> -->
  <div class="mess-shell__body">
    <router-outlet></router-outlet>
  </div>
  <!-- <app-academic-footers></app-academic-footers> -->
</div>
